import React from "react";

export default function PrivacyPolicy() {
  return (
    <div style={styles.page}>
      {/* Hero Section */}
      <div style={styles.hero}>
        <h1 style={styles.heading}>Privacy Policy</h1>
        <p style={styles.heroText}>
          Your privacy matters to us. PharmaHelp is committed to protecting
          your personal information and ensuring secure healthcare services.
        </p>
      </div>

      <div style={styles.container}>
        {/* Intro */}
        <div style={styles.card}>
          <h2>🔒 Our Commitment to Privacy</h2>
          <p>
            PharmaHelp values your privacy and is committed to protecting your
            personal data. We collect only the information necessary to provide
            medicines, healthcare products, prescription services, and customer
            support.
          </p>
        </div>

        {/* Information Collection */}
        <div style={styles.card}>
          <h2>📋 Information We Collect</h2>

          <ul style={styles.list}>
            <li>Name and contact details</li>
            <li>Phone number and email address</li>
            <li>Delivery address</li>
            <li>Prescription information</li>
            <li>Order and transaction details</li>
            <li>Customer support communications</li>
          </ul>
        </div>

        {/* Permissions */}
        <div style={styles.card}>
          <h2>📱 Permissions Used</h2>

          <div style={styles.permissionBox}>
            <div style={styles.permissionItem}>
              <h3>📷 Camera Access</h3>
              <p>Used for uploading prescriptions and healthcare documents.</p>
            </div>

            <div style={styles.permissionItem}>
              <h3>🖼️ Storage / Media Access</h3>
              <p>
                Allows users to select prescription images and related files.
              </p>
            </div>

            <div style={styles.permissionItem}>
              <h3>📍 Location Access</h3>
              <p>
                Helps us provide accurate delivery services and improve order
                fulfillment.
              </p>
            </div>
          </div>
        </div>

        {/* Data Usage */}
        <div style={styles.card}>
          <h2>🛡️ How We Use Your Data</h2>

          <ul style={styles.list}>
            <li>Processing and delivering orders</li>
            <li>Managing prescriptions</li>
            <li>Providing customer support</li>
            <li>Improving our services</li>
            <li>Sending order-related notifications</li>
          </ul>

          <p>
            We do not sell, rent, or share your personal information with
            unauthorized third parties.
          </p>
        </div>

        {/* Payments */}
        <div style={styles.card}>
          <h2>💳 Secure Payments</h2>

          <p>
            Payments are processed through trusted payment gateways such as
            Razorpay. PharmaHelp does not store your debit card, credit card,
            UPI PIN, or banking credentials.
          </p>
        </div>

        {/* Security */}
        <div style={styles.card}>
          <h2>🔐 Data Security</h2>

          <p>
            We implement appropriate security measures to protect customer
            information from unauthorized access, misuse, alteration, or
            disclosure.
          </p>
        </div>

        {/* User Rights */}
        <div style={styles.card}>
          <h2>👤 User Rights</h2>

          <p>
            Users may request correction, modification, or deletion of their
            personal information by contacting our support team.
          </p>
        </div>

        {/* Contact */}
        <div style={styles.card}>
          <h2>📞 Contact Us</h2>

          <p>
            If you have any questions regarding this Privacy Policy, please
            contact us:
          </p>

          <p>
            <strong>Email:</strong> info@pharmahelp.co.in
          </p>

          <p>
            <strong>Phone:</strong> 6395050131
          </p>
        </div>

        <div style={styles.footerBox}>
          <strong>PharmaHelp – Your Health, Our Priority.</strong>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    background: "#f4f7fb",
    minHeight: "100vh",
    paddingBottom: "40px",
  },

  hero: {
    background: "linear-gradient(135deg, #0f172a, #2563eb)",
    color: "#fff",
    textAlign: "center",
    padding: "60px 20px",
  },

  heading: {
    margin: 0,
    fontSize: "42px",
    fontWeight: "700",
  },

  heroText: {
    marginTop: "15px",
    fontSize: "18px",
    maxWidth: "750px",
    marginLeft: "auto",
    marginRight: "auto",
  },

  container: {
    maxWidth: "1000px",
    margin: "30px auto",
    padding: "20px",
  },

  card: {
    background: "#fff",
    padding: "25px",
    borderRadius: "14px",
    marginBottom: "20px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
  },

  list: {
    lineHeight: "2",
    paddingLeft: "20px",
  },

  permissionBox: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "15px",
  },

  permissionItem: {
    background: "#f8fafc",
    padding: "15px",
    borderRadius: "10px",
    border: "1px solid #e5e7eb",
  },

  footerBox: {
    marginTop: "20px",
    padding: "20px",
    textAlign: "center",
    background: "#eff6ff",
    borderRadius: "12px",
    color: "#1e40af",
    fontSize: "18px",
  },
};